import styled, { css } from 'styled-components';

export const Video = styled.video.withConfig({
  shouldForwardProp: (prop) => !['fill'].includes(prop),
})<{
  fill: boolean;
}>`
  ${({ fill }) =>
    fill &&
    css`
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
    `}
`;

export const VideoContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['aspectRatio'].includes(prop),
})<{
  aspectRatio: string;
}>`
  position: relative;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  overflow: hidden;

  &:has(.include-in-slider) {
    cursor: zoom-in;
    
    iframe {
      pointer-events: none;
    }
  }

  .loader-spinner.hidden,
  .vimeo-poster.hidden {
    opacity: 0 !important;
    pointer-events: none;
  }

  .loader-spinner.hidden {
    transition: opacity 0.8s ease-in-out;
  }

  .loader-spinner {
    opacity: 0.65;
    transition: opacity 0.3s ease-in-out;
  }

  .vimeo-poster {
      position: absolute !important;
      inset: 0;
      object-fit: cover;
      z-index: 3;            
      opacity: 1;
      transition: opacity .25s ease;
      pointer-events: none;   
  }

  .vimeo-poster.has-been-played {
    opacity: 0 !important;
  }

  &:fullscreen {
    background-color: black;

    iframe {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
      padding: 0;
      aspect-ratio: auto;
      background-color: black;
    }
  }

  img {
    transition: transform 0.3s;
  }

  video {
    transition: transform 0.5s;
  }

  div:not([class*="loader-spinner"]) {
    position: relative;
    height: 100%;
    width: 100%;
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent !important;

    &.include-in-slider {
      pointer-events: none;
    }
  }

  iframe[data-is-scaled='true'] {
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    height: 100%;
    border: none;
    transform: translate(-50%, -50%);
  }
`;

// by extending the observer area, we can make sure the video starts playing a bit earlier
// when the user scrolls down the page
export const ExtendedVideoObserver = styled.div`
  --observer-extension-height: 50vh;

  position: absolute;
  top: calc(var(--observer-extension-height) * -1);
  left: 0;
  height: calc(100% + var(--observer-extension-height)) !important;
  width: 100%;
  pointer-events: none;
`

export const ControlsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 5;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 0;
  }

  button {
    all: unset;
    cursor: pointer;

    position: absolute;
    height: 50px;
    width: 50px;
    /* background: var(--c-black-200);
    border-radius: 5px; */
  }

  .btn-fullscreen {
    right: 20px;
    bottom: 20px;
    z-index: 3;

    &:hover {
      img {
        transform: scale(1.05);
      }
    }
  }

  .btn-sound {
    right: 80px;
    bottom: 20px;
    z-index: 3;

    img {
      transform: scale(0.8);
      opacity: 1;
    }

    &:hover {
      img {
        transform: scale(0.85);
      }
    }
  }

  .exit-fullscreen-icon {
    opacity: 0;
  }
`;
